function initReviewSlider() {
  // Get dom elements
  const reviews = document.querySelectorAll<HTMLElement>('.tp-review');
  const navButtons = document.querySelectorAll<HTMLElement>('.tp-reviews__control');

  // Stop if elements not found on page
  if (!reviews || !navButtons) {
    return;
  }

  // Store slider state
  let activeIndex = 0;

  /**
   * Set a new active index
   *
   * @param {number} index
   */
  function setActive(index: number) {
    // Clamp index to loop around
    let targetIndex = index;
    if (targetIndex >= reviews.length) {
      targetIndex = 0;
    } else if (targetIndex < 0) {
      targetIndex = reviews.length - 1;
    }

    // Set classes
    reviews[targetIndex].classList.add('active');
    reviews[activeIndex].classList.remove('active');

    // Store new active index
    activeIndex = targetIndex;
  }

  navButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      const targetIndex = index === 1 ? activeIndex + 1 : activeIndex - 1;
      setActive(targetIndex);
    });
  });
}

export default initReviewSlider;
